/**
 * Created by toomasp on 29.07.2015.
 */

let directivesModule = angular.module('eservice.core.directives', []);


// validator directives
import dateRange from './validation/date-range.directive';
import email from './validation/email.directive';
import regex from './validation/regex.directive';
import password from './validation/password.directive';
import unique from './validation/unique.directive';
import phone from './validation/phone.directive';
import valid from './validation/valid.directive';
import personCode from './validation/person-code.directive';
import url from './validation/url.directive';

directivesModule
    .directive('daterange', dateRange)
    .directive('email', email)
    .directive('regex', regex)
    .directive('password', password)
    .directive('unique', unique)
    .directive('phone', phone)
    .directive('valid', valid)
    .directive('personcode', personCode)
    .directive('url', url)
;

// decorator directives
import translate from './decorator/translate.directive';
import clickOutside from './decorator/click-outside.directive';
import autocomplete from './decorator/autocomplete.directive';
import customerAutocomplete from './decorator/customer-autocomplete.directive';
import addressAutocomplete from './decorator/address-autocomplete/address-autocomplete.directive';
import datepicker from './decorator/datepicker.directive';
import errorMsg from './decorator/error-message.directive';
import synced from './decorator/synced.directive';
import tooltip from './decorator/tooltip.directive';
import scrollTo from './decorator/scroll-to.directive';
import proxyLink from './decorator/proxy-link.directive';
import proxyForm from './decorator/proxy-form.directive';
import placeholder from './decorator/placeholder.directive';
import ngTap from './decorator/ng-tap.directive';
import ngBlur from './decorator/ng-blur.directive';
import script from './decorator/script.directive';

directivesModule
    .directive('translate', translate)
    .directive('clickOutside', clickOutside)
    .directive('autocomplete', autocomplete)
    .directive('addressautocomplete', addressAutocomplete)
    .directive('customerautocomplete', customerAutocomplete)
    .directive('datepicker', datepicker)
    .directive('errorMsg', errorMsg)
    .directive('synced', synced)
    .directive('tooltip', tooltip)
    .directive('scrollTo', scrollTo)
    .directive('proxyLink', proxyLink)
    .directive('href', proxyLink)// TODO: remove this once periodics fixes their url-s
    .directive('proxyForm', proxyForm)
    .directive('placeholder', placeholder)
    .directive('ngTap', ngTap)
    .directive('ngBlur', ngBlur)
    .directive('script', script)
;

// widget directives


import simpleTableDirective from './widget/table/simple-table.directive';
import SimpleTableFactory from './widget/table/simple-table.model';
directivesModule.directive('simpletable', simpleTableDirective);
directivesModule.service('simpleTableFactory', SimpleTableFactory);

import pagerDirective from './widget/table/pager.directive';
import {PagerFactory} from './widget/table/pager.model';
directivesModule.directive('pager', pagerDirective);
directivesModule.service('pagerFactory', PagerFactory);


import gazetter from './widget/gazetter/gazetter.directive';
directivesModule.directive('gazetter', gazetter);

export default directivesModule;



// WEBPACK FOOTER //
// ./src/ui/core/common/directives/directives.js